import State from 'slotworks/state-machine/states/state';
import gameState from 'slotworks/model/game-state';
import SpinRecord from 'slotworks/model/gameplay/records/spin-record';
import regulation from 'slotworks/integration/revolver/regulations/regulation';
import Components from 'slotworks/components/components';
import BuyoutRecord from 'integration/revolver/schema/buyout-record';

export default class BuyoutBonus extends State {
    public onEnter() {
        this.newGame();
        this.complete();
    }
    private newGame() {
        const buyoutRecord = gameState.getCurrentGame().latestRecord() as BuyoutRecord;
        
        gameState.newGame();
        regulation.interactionStart();
        Components.betBar.winnings.setWinnings(0, 0);

        gameState.getCurrentGame().isBuyout = true;
        gameState.getCurrentGame().totalBet = buyoutRecord.totalBetCash;

        Components.betBar.setBalance(gameState.getCurrentGame().startBalance);
        Components.betMenu.setBalance(gameState.getCurrentGame().startBalance);

        gameState.getCurrentGame().isRecovered = true;
        gameState.getCurrentGame().records.push(buyoutRecord);
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/buyout-bonus.ts